import autobind from "autobind-decorator";
import pym from 'pym.js';
import React from "react";

import events from "common/events";
import { HTML } from "common/fragments/TextContent";
import { BlockView } from "common/views/block/BlockView.view";
import { IPanelProps, Panel } from "core/decorators/Panel";
import TokenSession from "../../core/util/session/TokenSession";
import UrlUtil from "../../core/util/UrlUtil";
import EmbedPanelConfig from "./EmbedPanelConfig";

@Panel({id: "embed", configClass: EmbedPanelConfig})
export default class EmbedPanel extends React.Component<IPanelProps<EmbedPanelConfig>> {
	private frameRef: any;

	constructor(props: IPanelProps<EmbedPanelConfig>) {
		super(props);
		this.frameRef = React.createRef();
	}

	@autobind
	private getUrl() {
		const { embedURL, createSession } = this.props.config;

		return createSession ? UrlUtil.getAuthorizedLink(TokenSession.getToken(), embedURL) : embedURL;
	}

	public componentDidMount() {
		const { onLoad, onUnLoad, onAjaxStart, onAjaxComplete } = this.props.config;

		if(this.frameRef.current) {
			const id = this.frameRef.current.getAttribute("id");
			const pymParent = new pym.Parent(id, this.getUrl(), {});

			if(onLoad) {
				pymParent.onMessage("window-load", () => {
					window.dispatchEvent(events[onLoad]);
				});
			}

			if(onUnLoad) {
				pymParent.onMessage("window-unload", () => {
					 window.dispatchEvent(events[onUnLoad]);
				});
			}

			if(onAjaxStart) {
				pymParent.onMessage("ajax-start", () => {
					window.dispatchEvent(events[onAjaxStart]);
				});
			}

			if(onAjaxComplete) {
				pymParent.onMessage("ajax-complete", () => {
					window.dispatchEvent(events[onAjaxComplete]);
				});
			}
		}
	}

	public render() {
		const { config, instance } = this.props;

		return (config.responsive ? (
				<div ref={this.frameRef} id={"frame-" + instance} />
			) : (
				<iframe style={{ height: config.height, width: '100%' }} src={this.getUrl()} />
			));
	}
}



// WEBPACK FOOTER //
// ./src/panels/embed/Embed.panel.tsx